module.exports = __webpack_public_path__ + "img/galerie-36.7cb84faa.jpg";